window.Order = {};
/*
window.Order.CDEK = {
	cdekWidget: null,
	init: function () {
		if (this.cdekWidget) return;
		if (typeof ISDEKWidjet == 'undefined') return;

		this.cdekWidget = new ISDEKWidjet({
			defaultCity: 'auto',
			hidedress: true,
			hidedelt: true,
			popup: true,
			apikey: App.mapKey
		});

		this.cdekWidget.binders.add(function (wat) {
			$dhelper = $('.delivery-helper[data-for=4]');

			$dhelper.find('[name=city_4]').val(wat.cityName);
			$dhelper.find('[name=address_4]').val(wat.PVZ.Address + ", ПВЗ #" + wat.id);

			var text = wat.cityName + ", ПВЗ # " + wat.id + '<br>Адрес: ' + wat.PVZ.Address;

			$selected = $dhelper.find('.selected-pvz');
			$selected.find('.address').html(text);
			$selected.show();
		}, 'onChoose');
	},
	open: function () {
		this.cdekWidget.open();
	},
};*/

$(document).ready(function () {
	let $formOrder = $("#form-order-make");

	$formOrder.find('[name=delivery_type]').on('change', function () {
		let sumRoute = $formOrder.data('sum-route');
		let promocode = $formOrder.data('promocode');
		let delivery_type = $(this).val();

		let params = {
			delivery_type: delivery_type,
			promocode: promocode
		};

		$.get(sumRoute, params, function (data) {
			if (!data.error) {
				var $checkoutTotals = $("#checkout-totals");
				var $priceList = $checkoutTotals.find('.price-list');

				$priceList.find('.sum-products .sum').html(data.products);
				$priceList.find('.sum-delivery .sum').html(data.delivery);

				if (isNaN(data.delivery)) {
					$priceList.find('.sum-delivery .icon').hide();
				} else {
					$priceList.find('.sum-delivery .icon').show();
				}

				$priceList.find('.sum-total .sum').html(data.total);
			}
		});
	});

	$formOrder.find('[name=delivery_type]').on('change', function () {
		let payments = $(this).data('payments');

		$formOrder.find('[name=payment_type]').each(function (i, e) {
			let id = parseInt($(e).attr('value'));

			if (payments.indexOf(id) !== -1) {
				$(e).removeAttr('disabled');
				$(e).closest('.container-radio').removeClass('disabled');
			} else {
				$(e).attr('disabled', 'disabled');
				$(e).closest('.container-radio').addClass('disabled');
			}
		});

		let $checkedPayment = $formOrder.find('[name=payment_type]:checked').first();
		if ($checkedPayment.is(':disabled')) {
			$formOrder.find('[name=payment_type]:not([disabled])')
				.first()
				.prop('checked', true);
		}
	});

	$formOrder.find('[name=delivery_type]').on('change', function () {
		let val = $(this).val(),
			$container = $('.delivery-helper');

		$container.hide();
		$container.find('.city').attr('required', false);
		$container.find('.address').attr('required', false);

		let $checked_type = $('.delivery-helper[data-for="' + val + '"]');
		let inputs = $checked_type.find('input[type=text]');

		if (inputs.length) {
			inputs.each(function () {
				let $self = $(this);

				if ($self.hasClass('city')) {
					$self.attr('required', true);
				}

				if ($self.hasClass('address')) {
					$self.attr('required', true);
				}
			});
		}

		$checked_type.slideToggle();
	});

	if ($formOrder.length) {
		$('[name=delivery_type]:checked').trigger('change');
	}
});
